export default "__VITE_ASSET__DodLCx8u__"